import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISingleIdParams } from '../../../ts/ServerApi/types/actionParams';
import { IMetricActions } from '../types/IMetricActions';

export class GetMetricActionsRequest extends Request<ISingleIdParams, IMetricActions> {
  constructor(id: string) {
    super('getMetricActions', { id: id });
  }
}
